/**
 * @deprecated Import from 'src/integrations/tanstack-start/index.js' instead.
 */
export {
  run as runTanstackStartInstallerAgent,
  config as TANSTACK_START_AGENT_CONFIG,
} from '../integrations/tanstack-start/index.js';
